/**
 * Набор цветов для меток проектов. Подобраны под тёмный фон: достаточно
 * насыщенные, чтобы отличаться точкой в 8 пикселей, и не спорят с акцентом.
 */
export const SPACE_COLORS = [
  '8a8a9a',
  'f5365d',
  'f5a623',
  'ffd60a',
  '10d97b',
  '2dd4bf',
  '4b8ef5',
  '8b5cf6',
  'ec4899',
  'f97316',
] as const;
